<template>
    <h6 class="tw-text-infinity-highlight" :class="{'tw-mb-3': !noMargin}">
        <slot></slot>
    </h6>
</template>
<script>
export default {
    name: 'BasePanelTitle',
    props: {
        noMargin: {
            type: Boolean,
            default: false
        }
    }
}
</script>
